module.exports = __webpack_public_path__ + "static/img/scarborough2.b7dc9f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/scarborough2.jpg
// module id = 133
// module chunks = 9